import axios, { AxiosRequestConfig } from 'axios';
import { AudioItem } from '@/components/ui/audio-player';

const API_BASE_URL = `${import.meta.env.VITE_API_URL}/api/tarot`;

export interface AudioGenerationResponse {
    success: boolean;
    audioUrls?: string[];
    totalAudioUrls?: string[];
    error?: string;
}

export const audioService = {
    async generateReadingAudio(readingId: string): Promise<AudioGenerationResponse> {
        const headers: AxiosRequestConfig['headers'] = {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
        };

        try {
            const response = await axios.post(
                `${API_BASE_URL}/reading/${readingId}/audio`,
                {},
                { headers }
            );

            return response.data;
        } catch (error: any) {
            console.error('Error generating audio:', error);
            return {
                success: false,
                error: error.response?.data?.error || 'Failed to generate audio'
            };
        }
    },

    async getReadingAudio(readingId: string): Promise<AudioGenerationResponse> {
        const headers: AxiosRequestConfig['headers'] = {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        };

        try {
            const response = await axios.get(
                `${API_BASE_URL}/reading/${readingId}/audio`,
                { headers }
            );

            return response.data;
        } catch (error: any) {
            console.error('Error getting audio:', error);
            return {
                success: false,
                error: error.response?.data?.error || 'Failed to get audio'
            };
        }
    }
}; 